// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e120361e","455":"54a1f18e","977":"6f56563f"}[chunkId] + ".chunk.js";
};